module.exports = {
      id: "aries-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#aries",
      toString: function () {
        return this.url;
      }
    }